<template>
  <modal @close="close">
    <div style="width: 100%">
      <md-table md-card>
        <md-table-toolbar>
          <h4>
            {{ currentSupplyName }}
          </h4>
        </md-table-toolbar>
        <md-table-row>
          <md-table-head>
          </md-table-head>
        </md-table-row>
        <md-table-row v-for="(oc, i) in currentOCs" :key="i">
          <md-table-cell>
            {{ oc }}
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>
  </modal>
</template>

<script>
import percentage from '@/filters/percentage'
import { shortDate } from "@/filters";

export default {
  props: {
    currentSupplyName: {
      type: String,
      required: true,
      default: '' 
    },
    currentOCs: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  filters: {
    percentage,
    shortDate,
  },
  data () {
    return {
    }
  },
  methods: {
    close() {
      this.$emit('close')
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Reports/InventoryLog/OCDetailsModal.vue